import { HttpClient } from '@opallabs/api'
import loadWorkflow from '../loadWorkflow'

const prefixFor = (type, identifier) =>
  type && identifier ? `${type}/${identifier}/` : ''

const putApproval = ({ identifier, type, workflowId, phaseId }) =>
  HttpClient().put(
    `/api/v1/${prefixFor(
      type,
      identifier
    )}workflow/${workflowId}/phases/${phaseId}/send`,
    { data: {} }
  )

const sendForApproval =
  ({ identifier, onSendForApproval, phaseId, type, workflowId }) =>
  (dispatch) =>
    putApproval({
      identifier,
      type,
      workflowId,
      phaseId,
    })
      .then((response) => {
        if (onSendForApproval) {
          onSendForApproval()
        }
        return dispatch(loadWorkflow(response.data))
      })
      .catch((err) => {
        console.log(err)
        throw err
      })

export default sendForApproval
